import { AbstractControl } from "@angular/forms";
import { isPersian } from '@persian-tools/persian-tools';

export function IsPersianValidator(controller: AbstractControl) {
    const value = controller.value;
    const check = !!(isPersian(value));

    return !!(check) ? null : {
        isPersian: {
            valid: false
        }
    };
}
